var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNervaLogoWithBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4665_1017)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.9143,
    cy: 19.3286,
    rx: 19.9143,
    ry: 19.3286,
    fill: "#367B6E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4665_1017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3367 22.4269C25.4421 23.5763 22.9391 23.3342 21.3034 21.6964C19.6656 20.0586 19.4235 17.5578 20.5729 15.6631L16.6805 11.7708C12.6618 15.7894 12.6618 22.3027 16.6805 26.3214C20.6992 30.3401 27.2125 30.3401 31.2312 26.3214L27.3388 22.429L27.3367 22.4269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8901 12.1098C28.966 10.1857 25.8483 10.1857 23.9242 12.1098C23.6379 12.3961 23.3937 12.7097 23.1937 13.0423C22.0443 14.9369 22.2864 17.4399 23.9242 19.0756C25.562 20.7134 28.0629 20.9555 29.9575 19.8061C30.2901 19.604 30.6038 19.3619 30.8901 19.0756C32.8142 17.1515 32.8142 14.0338 30.8901 12.1098V12.1098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4665_1017",
    x: 0,
    y: 0,
    width: 47.8286,
    height: 46.6571,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4665_1017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4665_1017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4665_1017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(9 6)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNervaLogoWithBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nervaLogoWithBackground.65c0ee6607b21db796c94d2dba3260be.svg";